<template>
  <div class="farm-map">
    <div class="map-bar" :class="{hidden : !fields.length, }">
        <field-selector
          @selectField="selectField"
          v-show="!activateFieldInfo"
        />
        <field-info
          v-if="activateFieldInfo && !$store.getters['satellite/is_opened']"
          :field="selected_field"
          @close="closeFieldInfo"
          @enableSatelliteView="enableSatelliteView"
        />

        <satellite-view @renderSatelliteImage="renderSatelliteImage" v-if="$store.getters['satellite/is_opened']"/>

    </div>

    <transition name="modal-fade-scale">
      <add-new-field
        v-if="openAddingPopup"
        :fieldGeometry="fieldGeometry"
        :fieldGeoType="fieldGeoType"
        :fieldLayer="fieldLayer"
        @close="closePopup"
      />
    </transition>

    <div class="map">
      <l-map
        :zoom="zoom"
        :center="center"
        :min-zoom="minZoom"
        :world-copy-jump="true"
        ref="map"
        :options="mapOptions"
      >
      <map-selector v-model="url" />
        <!-- <vue2-leaflet-google-mutant
          :apikey="$env.GOOGLE_MAPS_API_KEY"
          :options="googlemutantoptionsobject"
        /> -->

        <search-location @setPlace="setPlace" />
        <l-tile-layer :url="url"></l-tile-layer>
        <template v-for="field in fields">
          <l-polygon
            v-if="field.shape == 'polygon'"
            :lat-lngs="field.coordinates.map(n => parseCoords(n))"
            @click="openFieldInfo(field)"
            :color="selected_field.id === field.id ? '$mainGreen' : '#FFFFFF'"
            :fill-color="'#FFFFFF'"
          />
          <l-circle
            v-else-if="field.shape == 'radial'"
            :lat-lng="parseCoords(field.coordinates[0])"
            :radius="field.coordinates[0].radius"
            @click="openFieldInfo(field)"
            :color="selected_field.id === field.id ? '$mainGreen' : '#FFFFFF'"
            :fill-color="'#FFFFFF'"
          />
          <l-marker
           v-else
           :lat-lng="parseCoords(field.coordinates[0])"
           @click="openFieldInfo(field)"
           :color="selected_field.id === field.id ? '$mainGreen' : '#FFFFFF'"
           :fill-color="'#FFFFFF'"
           :icon="new customMarker()"
          />
        </template>
      </l-map>
    </div>
  </div>
</template>

<script>

import { LMap, LTileLayer, LMarker, LPolygon, LCircle } from 'vue2-leaflet'
import DrawLocales from 'leaflet-draw-locales'
import LDraw from 'leaflet-draw'
import { GestureHandling } from "leaflet-gesture-handling"
import API from '@/api'
import AddNewField from '@/components/fields/AddNewField'
import FieldInfo from '@/components/fields/FieldInfo'
import FieldSelector from '@/components/fields/FieldSelector'
import SearchLocation from '@/components/fields/SearchLocation'
import SatelliteView from '@/components/fields/SatelliteView'
import MapSelector from '@/components/fields/MapSelector'
import { mapGetters } from 'vuex'

export default {

  data() {
    return {
      activateFieldInfo: false,
      selected_field: {},
      openAddingPopup: false,
      fieldGeometry: null,
      fieldGeoType: null,
      fieldLayer: null,
      // googlemutantoptionsobject: {
      //   type: 'hybrid',
      //   language: 'en',
      //   libraries : 'places'
      // },
      zoom: 1,
      center: L.latLng(47.413220, -1.219482),
      url: 'https://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
      // url: `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}`,
      minZoom: 2,
      polygons: [],
      circles: [],
      userFarms: null,
      userFields: null,
      drawControl: null,
      mapOptions: {
        zoomSnap: 0.5,
        gestureHandling:true
      },
      customMarker : L.Icon.extend({
        options: {
          shadowUrl: null,
          iconAnchor: new L.Point(12, 12),
          iconSize: new L.Point(24, 24),
          iconUrl: `/favicon.png`
        }
      }),
    }
  },
  created() {

    this.$store.dispatch('satellite/close');
    if(
      !this.fields.length
    ) {
      this.$store.commit('modals/alert/open', {
        text: this.$ml.get(`Click on "Draw a polygon" to draw your first field`)
      });
      this.$store.commit('tutorials/setTutorial', {
        key: 'fields',
        value: true,
      });
    }
  },
  mounted() {
    this.setPlace();
    const map = this.$refs.map.mapObject;


    if(this.fields.length) {
      const myBounds = new L.LatLngBounds(this.$store.getters['farms/fieldsLatLgnBounds']);
      map.fitBounds(myBounds); // calculate center and zoom of map, if user fields exists
    }


    window.addEventListener('resize', this.onPageResize);

    this.$nextTick(() => {

      var editableLayers = new L.FeatureGroup();
      map.addLayer(editableLayers);

      if(this.$store.getters['user/lang'] != 'jp' && this.$store.getters['user/lang'] != 'zh') {
        L.drawLocal = DrawLocales(this.$store.getters['user/lang']);
      } else {
        L.drawLocal = DrawLocales('en');
      }


      this.drawControl = new window.L.Control.Draw({
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            drawError: {
              color: '#E8282F', // Color the shape will turn when intersects
              message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
            },
            shapeOptions: {
              color: '#FFFFFF'
            },
            showArea: true,
          },
          polyline: false,
          circle: {
            allowIntersection: false,
            drawError: {
              color: '#E8282F', // Color the shape will turn when intersects
              message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
            },
            shapeOptions: {
              color: '#FFFFFF'
            },
            showArea: true,
          },
          rectangle: false,
          // marker: false,
          marker: {
            icon: new this.customMarker(), //Here assign your custom marker
          },
          circlemarker: false
        },
        edit: {
          featureGroup: editableLayers,
          remove: false
        }
      });

      map.addControl(this.drawControl);

      // event когда заканчиваешь draw
      map.on('draw:created', this.onFieldAdded);

    });

    if(this.$route.params.satellite && this.$route.params.fieldId) {
      // console.log('yeah boi');
      let id = this.$route.params.fieldId;
      this.selectField(id);
      this.$store.dispatch('satellite/open');
      this.$store.dispatch('satellite/selectField', id);
    }
  },
  methods: {
    renderSatelliteImage() {
      let prev_imgs = document.querySelectorAll('.leaflet-image-layer');
      if(prev_imgs[0]) {
        prev_imgs[0].remove();
      }

      let field = this.satelliteField;
      let map = this.$refs.map.mapObject;

      let coordinates = field.coordinates.map(n => this.parseCoords(n))
      if(this.imageURL) {
        let img = L.imageOverlay(
          this.imageURL,
          coordinates,
          {
            opacity: 1,
          }
        );

        img.addTo(map).bringToFront();
      }


    },

    enableSatelliteView(id) {
      console.log('Field ID: ', id);
    },

    getUserLocation() {
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    },

    setMapCenter(latLng) { // получать данные обёрнутые в L.latLng()
      this.center = latLng;
      this.zoom = 12;
    },

    setPlace(latLng = null) {
      if(latLng == null) {
        this.getUserLocation()
          .then((pos) => {
            if(!this.fields.length) {
              this.setMapCenter( L.latLng(pos.coords.latitude, pos.coords.longitude) );
            }

          })
          .catch((err) => {
            console.error(err.message);
          });
      }else {
        this.setMapCenter( L.latLng(latLng.lat, latLng.lng) );
      }

    },

    parseCoords(n) {
      return [ parseFloat(n.latitude), parseFloat(n.longitude) ];
    },

    onFieldAdded(e) {

      this.fieldGeoType = e.layerType;
      if(this.fieldGeoType == 'polygon') {
        this.fieldGeometry = e.layer.editing.latlngs;
      }
      else if (this.fieldGeoType == 'circle') {
        this.fieldGeometry = {
          radius : e.layer._mRadius,
          center : e.layer._latlng
        }
      } else if (this.fieldGeoType == 'marker') {
        this.fieldGeometry = e.layer.editing._marker._latlng;
        // console.log(e.layer.editing._marker._latlng);
      }

      this.openAddingPopup = true;
      this.fieldLayer = e.layer;
    },

    closePopup() {
      this.openAddingPopup = false;
      this.fieldGeometry = null;
      this.fieldGeoType = null;
      this.fieldLayer = null;
    },

    selectField(id) {
      let field = this.fields.find(x => x.id == id);
      this.fitByField(field.coordinates);
      this.selected_field = field;
      this.activateFieldInfo = true;
    },

    fitByField(coordinates){
      let LatLngs = [];

      coordinates.map(function(el) {
          let bound = [ el.latitude, el.longitude ];
          bound = Object.values(bound)
          LatLngs.push(bound);
      });

      let bounds = new L.LatLngBounds( Object.values(LatLngs) );

      this.$refs.map.mapObject.fitBounds(bounds); // calculate center and zoom of map
    },

    openFieldInfo(field) {
      this.fitByField(field.coordinates);
      this.$store.dispatch('satellite/close');
      this.selected_field = field;
      this.activateFieldInfo = true;
    },

    closeFieldInfo() {
      this.selected_field = {};
      this.activateFieldInfo = false;
    },

    onPageResize() {
      this.windowHeight = window.innerHeight;
    }
  },
  computed: {
    ...mapGetters({
      fields: 'farms/fields',
      farms: 'farms/farms',
      imageURL: 'satellite/image',
      satelliteField: 'satellite/fieldInfo',
    })
  },
  components : {
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    AddNewField,
    FieldInfo,
    LCircle,
    LDraw,
    DrawLocales,
    SearchLocation,
    FieldSelector,
    SatelliteView,
    MapSelector,
  },
  destroyed() {
    window.removeEventListener('resize', this.onPageResize);
  }
}
</script>

<style lang="scss" scoped>
.farm-map {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media(min-width:1000px) and (min-height:600px) {
    max-height: 100vh;
  }
  .map-bar {
    width: 320px;
    margin-right: 8px;
    height: 100%;
    &.hidden {
      display: none;
    }
  }
  .map {
    flex-grow: 1;
    height: 100%;
    min-height: 70vh;
    overflow: hidden;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    &::v-deep {
      .vue2leaflet-map {
        height: 600px;
        flex-grow: 1;
      }
    }
    // background-color: #000;
  }
  @media(max-width:768px) {
    .map {
      // min-height: 600px;
      // min-height: 80vh;
      display: flex;
      flex-direction: column;
      &::v-deep {
        .leaflet-container {
          // min-height: 70vh;
          height: 100%;
          flex-grow: 1;
        }
      }
    }
  }
}
</style>

<style lang="css">

#main {
  height: 100%;
}

</style>
